// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import ExploreSlide from './ExploreSlide';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const defaultProps = {};
const contextType = {};

function Explore(props) {
  const {
    slides,
  } = props;
  return (
    <div className="explore">
      {slides && slides.map(slide =>
        <ExploreSlide
          key={`landing_explore_${slide.id}`}
          slide={slide}
        />,
      )}
    </div>
  );
}

Explore.propTypes = propTypes;
Explore.defaultProps = defaultProps;
Explore.contextTypes = contextType;

export default Explore;



// WEBPACK FOOTER //
// ./src/app/components/pages/landing/explore/Explore.js